// Module
var code = "<div class=\"faq-question-container\"> <div class=\"text-light-black\" [innerHTML]=\"sanitizedHtml\" [ngClass]=\"isRebrading ? 'text-regular' : 'text-light'\"></div> </div> ";
// Exports
module.exports = code;